'use strict';

/**
 * Инит магнифика, тип image, с галереей
 * @module
 * @see {@link http://dimsemenov.com/plugins/magnific-popup/documentation.html#image-type}
 * @see {@link http://dimsemenov.com/plugins/magnific-popup/documentation.html#gallery}
 */

// ----------------------------------------
// Imports
// ----------------------------------------

import Preloader from '../Preloader';

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Инит метода
 * @param {JQuery.Selector} [selector="[data-mfp-src]"]- поиск элементов по селектору
 * @param {JQuery} [$context=$('.js-mfp-gallery')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @private
 * @sourceCode
 */
function init (selector, $context, userConfig) {
	$context.each((i, el) => {
		let $element = $(el);
		let delegateTarget = $element.data('delegate');
		if (delegateTarget) {
			selector = delegateTarget;
		}
		let config = $.extend(true, {
			type: 'image',
			delegate: selector,
			gallery: {
				enabled: true,
				preload: [0, 2],
				navigateByImgClick: true,
				arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>'
			},
			closeBtnInside: true,
			removalDelay: 300,
			mainClass: 'mfp-animate-zoom-in',
			callbacks: {
				elementParse: function (item) {
					if ($(item.el).hasClass('js-gallery-video')) {
						item.type = 'iframe';
						item.iframe = {
							patterns: {
								youtube: {
									index: 'youtube.com/',
									id: 'v=',
									src: '//www.youtube.com/embed/%id%?autoplay=1'
								},
								vimeo: {
									index: 'vimeo.com/',
									id: '/',
									src: '//player.vimeo.com/video/%id%?autoplay=1'
								},
								gmaps: {
									index: '//maps.google.',
									src: '%id%&output=embed'
								}
							}
						};
					} else {
						item.type = 'image';
						item.tLoading = 'Loading image #%curr%...';
						item.mainClass = 'mfp-img-mobile';
					}
				}
			}
		}, userConfig);

		$element.magnificPopup(config);

		$(document).on('galleryClose', function () {
			if ($element.is($.magnificPopup.instance.ev[0])) {
				$($.magnificPopup.instance.wrap).trigger('click');
				$element.on('mfpClose', function () {
					$(document).trigger('galleryClosed');
				});
			} else {
				$(document).trigger('galleryClosed');
			}
		});
	});
}

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * Загрузка по требованию
 * @param {JQuery.Selector} [selector="[data-mfp-src]"]- поиск элементов по селектору
 * @param {JQuery} [$context=$('.js-mfp-gallery')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @sourceCode
 */
function mfpGallery (selector = '[data-mfp-src]', $context = $('.js-mfp-gallery'), userConfig = {}) {
	/**
	 * @param {JQuery.Event} event
	 */
	function load (event) {
		event.preventDefault();
		$context.off('click', selector, load);

		let $element = $(this);
		let preloader = new Preloader($element);
		preloader.show();

		import(
			/* webpackChunkName: "magnific-popup" */
			'./mfp'
		).then(() => {
			init(selector, $context, userConfig);
			preloader.hide();
			$element.trigger(event.type);
		});
	}

	$context.on('click', selector, load);
}

$('.js-delegate-link').on('click', function () {
	$($(this).data('delegate-target')).first().trigger('click');
});

// ----------------------------------------
// Exports
// ----------------------------------------

export default mfpGallery;



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/mfp/mfp-gallery.js